/**
 * Payment methods — `/betting-gaming/payment-methods`
 */
import { PAYMENT_METHODS_SLUG, paymentMethodsDefaultData } from "./paymentMethodsData";
import { PaymentMethodsArticlesTab, PaymentMethodsMediaTab, PaymentMethodsOverviewTab } from "./PaymentMethodsDesign";

export const paymentMethodsModule = {
  slug: PAYMENT_METHODS_SLUG,
  getDefaultData: () => paymentMethodsDefaultData,
  Views: {
    overview: PaymentMethodsOverviewTab,
    articles: PaymentMethodsArticlesTab,
    media: PaymentMethodsMediaTab,
  },
};
